import { render } from "./OrderDataStatsPage.vue?vue&type=template&id=297c5845&scoped=true&ts=true"
import script from "./OrderDataStatsPage.vue?vue&type=script&lang=ts"
export * from "./OrderDataStatsPage.vue?vue&type=script&lang=ts"

import "./OrderDataStatsPage.vue?vue&type=style&index=0&id=297c5845&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-297c5845"]])

export default __exports__